module.exports = __webpack_public_path__ + "img/chuangsai_44.51f7bdee.jpg";